import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { BiltyLoadAndTripDetailsCss as useStyles } from '../BiltyCss';
import {
    IconButton,
    Switch,
    Grid,
    Button,
    MenuItem,
    InputAdornment,
    FormHelperText
} from '@material-ui/core';
import * as logger from '../../../../logger';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import AddIcon from '@material-ui/icons/Add';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { getMaterials, getElrInfo, addMaterial, biltyDataPopulated, biltyContinueClick } from '../../../../store/actions/tripActionCreator';
import { numberFormat, capitalizeTheWord } from '../../../../utils/utils';
import { RoundArrowIcon } from '../../../../components/icons';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import clsx from 'clsx';
import TextInputState from '../../../components/Inputs/TextInputState';

const filter = createFilterOptions({
    limit: 30
});

export const BiltyLoadAndTripDetails = ({ user, trip, dispatchGetMaterials, dispatchAddNewMaterial, open, dispatchBiltyContinueClick, dispatchBiltyDataPopulated, onDataPopulated }) => {

    let submit;

    const classes = useStyles();

    const elrId = user && user.singleTripData && user.singleTripData.elr_id ? user.singleTripData.elr_id : "";
    const tripData = user && user.singleTripData ? user.singleTripData : "";

    const [itemsValue, setItemsValue] = useState("");
    const [weightValue, setWeightValue] = useState("");
    const [unitValue, setUnitValue] = useState("Tonnes");
    const [materialValue, setMaterialValue] = useState("");
    const [paidByValue, setPaidByValue] = useState("Consignor");
    const [gstPercentageValue, setGstPercentageValue] = useState("");
    const [gstPaidByValue, setGstPaidByValue] = useState("Consignor");
    const [materialError, setMaterialError] = useState(false);
    const [materialListValue, setMaterialListValue] = useState([]);

    const initialValues = {
        material: materialValue,
        weight: weightValue,
        paidBy: paidByValue,
        unit: unitValue,
        gstPaidBy: gstPaidByValue,
        items: itemsValue,
        gstPercentage: gstPercentageValue,
    }

    useEffect(() => {
        if (trip && trip.materialList) {
            setMaterialListValue(trip.materialList);
        }
    }, [trip.materialList])

    useEffect(() => {

        if (trip && trip.elrInfo && trip.elrInfo.load_details) {
            setWeightValue(trip.elrInfo.load_details.product_weight != "None" ? trip.elrInfo.load_details.product_weight : "");
            setMaterialValue(trip.elrInfo.load_details.product_details.material_category);
            setPaidByValue(trip.elrInfo.load_details.freight_paid_by ? trip.elrInfo.load_details.freight_paid_by : "Consignor");
            setUnitValue(trip.elrInfo.load_details.product_weight_unit ? trip.elrInfo.load_details.product_weight_unit : "Tonnes");
            setGstPaidByValue(trip.elrInfo.load_details.gst_paid_by ? trip.elrInfo.load_details.gst_paid_by : "Consignor");
            setItemsValue(trip.elrInfo.load_details.number_of_bags ? trip.elrInfo.load_details.number_of_bags : "");
            setGstPercentageValue(trip.elrInfo.load_details.gst_percent ? trip.elrInfo.load_details.gst_percent : "");
        }

    }, [trip.elrInfo, trip.materialList]);

    useEffect(() => {

        dispatchGetMaterials(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Bilty Load And Trip Details Dweb', 'Get materials successfull');
                }
            },
            () => {
                logger.log('Bilty Load And Trip Details Dweb', 'Get materials failed');
            }
        );

    }, [open]);

    useEffect(() => {

        if (materialValue) {

            const index = trip.materialList.findIndex(x => x.material_category === materialValue);

            const material = trip.materialList[index];

            const values = {
                load_details: {
                    product_weight_unit: unitValue,
                    gst_percent: gstPercentageValue,
                    number_of_bags: itemsValue,
                    product_weight: weightValue,
                    product_id: material && material.id ? material.id : "",
                    freight_paid_by: paidByValue,
                    gst_paid_by: gstPaidByValue
                }
            }

            onDataPopulated(values);

            dispatchBiltyDataPopulated(true);
        } else {
            dispatchBiltyDataPopulated(false);
        }

        if (trip.biltyContinueClick) {
            onSubmit();
        }

    }, [materialValue, weightValue, paidByValue, unitValue, gstPaidByValue, itemsValue, gstPercentageValue, trip.biltyContinueClick, trip.materialList]);

    useEffect(() => {

        dispatchBiltyContinueClick(false);

    }, [materialValue, weightValue, paidByValue, unitValue, gstPaidByValue, itemsValue, gstPercentageValue, open])

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV2}>
                            <div className={classes.divTitleV1}>Material Category*</div>
                            {materialListValue && (materialListValue.length > 0 || !materialValue) &&
                                <>
                                    <Autocomplete
                                        classes={{
                                            listbox: classes.listBoxAutoCompelete,
                                            option: classes.listBoxOption
                                        }
                                        }
                                        id="select-material-list"
                                        name="material"
                                        size="small"
                                        placeholder="Eg: Steel"
                                        className={classes.textFieldV2}
                                        classes={{ inputRoot: classes.autoCompleteV1 }}
                                        autoHighlight
                                        error={materialError}
                                        options={materialListValue && materialListValue.length > 0 ? materialListValue : []}
                                        selectOnFocus
                                        clearOnBlur
                                        handleHomeEndKeys
                                        getOptionValue={option => option.material_category}
                                        onChange={(event, newValue) => {
                                            //createNewParty(newValue)
                                            setMaterialError(false);
                                            if (newValue && newValue.material_category) {
                                                setMaterialValue(newValue.material_category.replace(/\"/ig, ""))
                                            } else {
                                                setMaterialValue("");
                                            }
                                        }}
                                        getOptionLabel={(option) => {
                                            // if (typeof option === 'string') {
                                            //     return '';
                                            // }
                                            // if (option.inputValue || !option.id) {
                                            //     return '';
                                            // }
                                            return option.material_category.replace(/\"/ig, "");
                                        }}
                                        disableCloseOnSelect={false}
                                        filterOptions={(options, params) => {
                                            const filtered = filter(options, params);
                                            if (params.inputValue !== '') {
                                                filtered.unshift({
                                                    inputValue: params.inputValue,
                                                    material_category: `"${capitalizeTheWord(params.inputValue)}"`,
                                                });
                                            }
                                            return filtered;
                                        }}
                                        renderOption={(option, { selected, inputValue }) => {
                                            let matchesName;
                                            let partsName;
                                            matchesName = match(option.material_category, inputValue);
                                            partsName = parse(option.material_category, matchesName);

                                            if (option && option.id) {
                                                return (
                                                    <div className={classes.divListItem}>
                                                        {partsName.map((part, index) => {
                                                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                                                {part.text}
                                                            </span>
                                                            )
                                                        })}
                                                    </div>
                                                );

                                            } else {
                                                return (
                                                    <div className={classes.divAlignV4} onClick={() => handleAddNewMaterial(option.material_category.toString())}>
                                                        <div className={classes.divV2}>
                                                            <div>
                                                                <AddIcon className={classes.addIcon} />
                                                            </div>
                                                            <div className={classes.divV3}>
                                                                <div className={classes.divV5}>Tap to add material &nbsp;&nbsp;</div>

                                                                <span className={classes.divV4} >
                                                                    {partsName.map((part, index) => {
                                                                        return (<span key={index} style={{ color: '#0033cc' }}>
                                                                            {part.text}
                                                                        </span>
                                                                        )
                                                                    })}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <ChevronRightIcon className={classes.cherveRightIcon} />
                                                    </div>
                                                );
                                            }

                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Eg: Steel"
                                                variant="outlined"
                                                name="material"
                                                margin='normal'
                                                error={materialError}
                                                style={{ margin: 0, marginTop: 6 }}
                                            />
                                        )}
                                        multiple={false}
                                    />

                                    {materialError &&
                                        <FormHelperText error={materialError} className={classes.divError}>Please select material</FormHelperText>
                                    }
                                </>
                            }

                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.divV1}>
                            <div className={classes.widthV1}>
                                <div className={classes.divTitleV1}>Weight</div>
                                <TextInputState
                                    placeholder="Eg: 5"
                                    name="weight"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textV1}
                                    onChange={(e) => setWeightValue(e.target.value)}
                                />
                            </div>
                            <div className={classes.widthV1}>
                                <div className={classes.divTitleV1}>Unit</div>
                                <Select name="unit" className={classes.textV1} variant="outlined" onChange={(e) => setUnitValue(e.target.value)}>
                                    <MenuItem value="Tonnes">Tonnes</MenuItem>
                                    <MenuItem value="Kg">KGs</MenuItem>
                                </Select>
                            </div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>No. of Bags / Box / Shipments</div>
                            <TextInputState
                                placeholder="Eg: 5"
                                name="items"
                                variant="outlined"
                                size="small"
                                className={classes.textV1}
                                onChange={(e) => setItemsValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>FREIGHT PAID BY</div>
                            <Radios
                                name="paidBy"
                                radioGroupProps={{ row: true }}
                                data={[
                                    { label: 'Consignor', value: 'Consignor' },
                                    { label: 'Consignee', value: 'Consignee' },
                                    { label: 'Agent', value: 'Agent' }
                                ]}
                                formControlLabelProps={{
                                    className: classes.labelV1
                                }}
                                onChange={(e) => { setPaidByValue(e.target.value) }}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV3}>
                            <div className={classes.divTitleV1}>GST Percentage</div>
                            <TextInputState
                                placeholder="Eg: 5"
                                name="gstPercentage"
                                variant="outlined"
                                size="small"
                                className={classes.textV1}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            %
                                        </InputAdornment>
                                    )
                                }}
                                onChange={(e) => setGstPercentageValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: values.gstPercentage,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>GST PAID BY</div>
                            <Radios
                                name="gstPaidBy"
                                radioGroupProps={{ row: true }}
                                data={[
                                    { label: 'Consignor', value: 'Consignor' },
                                    { label: 'Consignee', value: 'Consignee' },
                                    { label: 'Agent', value: 'Agent' }
                                ]}
                                formControlLabelProps={{
                                    className: classes.labelV1
                                }}
                                onChange={(e) => setGstPaidByValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const onSubmit = values => {

        if (!materialValue) {
            setMaterialError(true);
        }

    }

    const handleAddNewMaterial = (value) => {

        const materialData = {
            material_category: value.replace(/\"/ig, "")
        }

        dispatchAddNewMaterial(materialData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Bilty Load And Trip Details Dweb', 'Add new material successfull');
                    dispatchGetMaterials(
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log('Bilty Load And Trip Details Dweb', 'Get materials successfull');
                                setMaterialValue(value.replace(/\"/ig, ""));
                            }
                        },
                        () => {
                            logger.log('Bilty Load And Trip Details Dweb', 'Get materials failed');
                        }
                    );
                }
            },
            () => {
                logger.log('Bilty Load And Trip Details Dweb', 'Add new material failed');
            }
        )
    }

    return (
        <>
            <div>

                <div className={classes.divMainContainer}>
                    <div className={classes.divText} >Trip Details</div>
                    <div className={classes.divSubContainner}>
                        <div className={classes.divHeader}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                                className={classes.gridV3}
                            >
                                <Grid className={classes.gridV2}>
                                    <div className={classes.divFlex}>
                                        <div className={classes.divWidth}>
                                            <div className={classes.textV3}>{tripData && tripData.startLocation ? tripData.startLocation : ""}</div>
                                            <div className={classes.startDate}>{tripData && tripData.startDate ? tripData.startDate : ""}</div>
                                        </div>
                                        <div className={classes.dividerV1}></div>
                                    </div>
                                </Grid>

                                <div>
                                    <RoundArrowIcon className={classes.fsV1} />
                                </div>

                                <Grid className={classes.gridV1}>
                                    <div className={classes.divFlex}>
                                        <div className={classes.dividerV2}></div>
                                        <div className={classes.divWidth}>
                                            <div className={classes.textV3}>{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</div>
                                            <div className={classes.endDate}>{tripData && tripData.completeDate ? tripData.completeDate : "--"}</div>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className={classes.divContent}>
                            <div className={classes.divAlignV1}>
                                <div>
                                    <div className={classes.divTitleV2}>Party Name</div>
                                    <div className={classes.divValue}>{tripData && tripData.party && tripData.party.name ? tripData.party.name : ""}</div>
                                </div>

                                <div className={classes.alignEnd}>
                                    <div className={classes.divTitleV2}>Billing Type</div>
                                    <div className={classes.divValue}>{tripData && tripData.billingType ? tripData.billingType : ""}</div>
                                </div>
                            </div>

                            <div className={classes.divAlignV2}>
                                <div>
                                    <div className={classes.divTitleV2}>Freight Amount</div>
                                    <div className={classes.divValue}>{numberFormat(tripData && tripData.freightAmount ? tripData.freightAmount : "")}&nbsp;&nbsp;
                                        {tripData && tripData.billingDetails && tripData.billingDetails.unitPrice && tripData.billingDetails.totalUnits &&
                                            <span className={classes.textV2}>({tripData.billingDetails.unitPrice + '*' + tripData.billingDetails.totalUnits})</span>
                                        }
                                    </div>
                                </div>

                                <div className={classes.alignEnd}>
                                    <div className={classes.divTitleV2}>Party Balance</div>
                                    <div className={classes.divValue}>{numberFormat(tripData && tripData.partyBalance ? tripData.partyBalance : "")}</div>
                                </div>
                            </div>

                            {tripData && tripData.partyCharges && tripData.partyCharges.length > 0 &&
                                <div className={classes.divChargesContainer}>
                                    {tripData && tripData.partyCharges && tripData.partyCharges.map((charge) => (
                                        <>
                                            <div className={classes.divAlignV3}>
                                                <div className={classes.divTitleV3}>{charge.displayName}</div>
                                                <div>{numberFormat(charge.amount)}</div>
                                            </div>
                                        </>
                                    ))
                                    }
                                </div>
                            }

                        </div>
                    </div>
                </div>

                <div className={classes.divContentV1}>
                    <div className={classes.divLoad}>Load Details</div>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        className={classes.mtV2}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                    {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                                </form>
                            )
                        }}
                    />

                </div>

            </div>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetMaterials: (onSuccess, onError) => {
        dispatch(getMaterials(onSuccess, onError))
    },
    dispatchAddNewMaterial: (materialData, onSuccess, onError) => {
        dispatch(addMaterial(materialData, onSuccess, onError))
    },
    dispatchBiltyDataPopulated: (value) => {
        dispatch(biltyDataPopulated(value))
    },
    dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyLoadAndTripDetails)